'use client';

import Box from '@mui/material/Box';
import { LandingHeader } from '../landing/LandingHeader';
import { LandingFooter } from '../landing/LandingFooter';
import { HeroSection } from './sections/HeroSection';
import { UseCasesSection } from './sections/UseCasesSection';
import { PainPointSection } from './sections/PainPointSection';
import { SolutionSection } from './sections/SolutionSection';
import { HowItWorksSection } from './sections/HowItWorksSection';
import { SocialProofSection } from './sections/SocialProofSection';
import { CtaSection } from './sections/CtaSection';

interface EventFaqBotPageProps {
  locale: string;
}

export function EventFaqBotPage({ locale }: EventFaqBotPageProps) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <LandingHeader />
      <Box component="main" sx={{ flex: 1 }}>
        <HeroSection locale={locale} />
        <UseCasesSection />
        <PainPointSection />
        <SolutionSection />
        <HowItWorksSection />
        <SocialProofSection />
        <CtaSection locale={locale} />
      </Box>
      <LandingFooter />
    </Box>
  );
}
